import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import DeleteDialog from '@Components/DeleteDialog/DeleteDialog';
import EntitiesApi from '@Data/entities/Api';
import { QualityControlApi } from '@Data/qualityControl/Api';
import { IReworkReason } from '@Data/qualityControl/Interfaces';
import QcStyles from '@Views/QualityControl/InProgressView.scss';
import Styles from './QualityControlBlock.scss';
import { QcBlockFooter } from './components/Footer/QcBlockFooter';
import { AddReworkHeader } from './components/JobInfo/AddReworkHeader';
import { BasicJobInfo } from './components/JobInfo/BasicJobInfo';
import { Stats } from './components/JobInfo/Stats';
import ManageReworkDialog from './components/ManageRework/ManageReworkDialog';
import { OutroDialog } from './components/OutroDialog/OutroDialog';
import { ReworkTable } from './components/ReworkTable/ReworkTable';
import { REWORK_AREA_CONTAINER_ID } from './constants';

export const QualityControlBlock = () => {
    const [selectedReworkReason, setSelectedReworkReason] =
        useState<IReworkReason>(null);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] =
        useState<boolean>(false);
    const [isManageReworkDialogueOpen, setIsManageReworkDialogOpen] =
        useState<boolean>(false);
    const [isOutroDialogOpen, setIsOutroDialogOpen] = useState<boolean>(false);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    useEffect(() => {
        QualityControlApi.getReworkStageTopicReasons();
    }, []);

    const handleOpenDeleteReworkDialog = (reworkReason: IReworkReason) => {
        setSelectedReworkReason(reworkReason);
        setIsDeleteDialogOpen(true);
    };

    const handleOpenEditReworkDialog = (reworkReason: IReworkReason) => {
        setSelectedReworkReason(reworkReason);
        setIsManageReworkDialogOpen(true);
    };

    const handleCloseDialogs = () => {
        setIsDeleteDialogOpen(false);
        setSelectedReworkReason(null);
        setIsManageReworkDialogOpen(false);
        setIsOutroDialogOpen(false);
    };

    const handleSubmitReworkReason = (
        reason: IReworkReason,
        comment: string
    ) => {
        if (_isNil(selectedReworkReason)) {
            QualityControlApi.addReworkReason(reason, comment);
        } else {
            QualityControlApi.updateReworkReason(
                selectedReworkReason,
                reason,
                comment
            );
        }
    };

    const handleDeleteReworkReason = () => {
        setIsDeleting(true);
        QualityControlApi.removeReworkReason(selectedReworkReason);
        setIsDeleting(false);
        handleCloseDialogs();
    };

    const handleCancelQcRun = () => {
        QualityControlApi.reset();
        EntitiesApi.clearEntity();
    };

    const handleGetNextPole = () => {
        QualityControlApi.getNextEntity();
    };

    const innerHtml = isManageReworkDialogueOpen ? (
        <ManageReworkDialog
            onClose={handleCloseDialogs}
            selectedReason={selectedReworkReason}
            onSubmit={handleSubmitReworkReason}
        />
    ) : (
        <>
            <div className={Styles.dataTablesContainer}>
                <BasicJobInfo />
                <Stats />
            </div>
            <div className={Styles.reworkArea} id={REWORK_AREA_CONTAINER_ID}>
                <AddReworkHeader
                    onClick={() => setIsManageReworkDialogOpen(true)}
                />
                <ReworkTable
                    onDelete={handleOpenDeleteReworkDialog}
                    onEdit={handleOpenEditReworkDialog}
                />
                <QcBlockFooter
                    onCancel={handleCancelQcRun}
                    onFinish={() => setIsOutroDialogOpen(true)}
                    onNext={handleGetNextPole}
                />
            </div>
        </>
    );

    return (
        <>
            <div className={QcStyles.qcblockContainer}>{innerHtml}</div>
            <DeleteDialog
                isOpen={isDeleteDialogOpen}
                onClose={handleCloseDialogs}
                isDeleting={isDeleting}
                onDelete={handleDeleteReworkReason}
                entityName={selectedReworkReason?.description}
                id="deleteReworkReasonDialog"
            />
            <OutroDialog
                isOpen={isOutroDialogOpen}
                onCancel={handleCloseDialogs}
            />
        </>
    );
};
